import React, { useState, useEffect } from "react";
import api from "../../../../Axios/api";
import MaterialTable from "material-table";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import AssessmentIcon from "@material-ui/icons/Assessment";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";
import HighlightOffRoundedIcon from "@material-ui/icons/HighlightOffRounded";

import {
  Chip,
  Switch,
  MenuItem,
  Grid,
  Paper,
  Modal,
  TextField,
  Container,
  Typography,
  Button,
  FormControl,
  InputLabel,
  Select,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { useUserContext } from "../../../../context/UserContext";
import ImgNotAvailable from "../../../../assets/images/imgNotAvailable.jpg";

import Pal from "../../../../themes/palette";
import useStyles from "./styles";

export default function ViewAllStores() {
  const classes = useStyles();
  const { store } = useUserContext();
  const token = store.data.token;

  const [storeDetails, setStoreDetails] = useState({
    name: "",
    category: "",
    biography: "",
    warehouseAddress: "",
    buissnessAddress: "",
    city: "",
    country: "",
    type: "",
    isApprovedPromotionTool: null,
  });
  const handleStoreDetails = (input) => (e) => {
    setStoreDetails({ ...storeDetails, [input]: e.target.value });
  };

  /////////////// Snackbar///////////////////////////////////////////////////////////////////
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };

  ///////////////Snack Bar End ///////////////////////////////////////////////////////////////////
  const [details, setDetails] = useState();
  const [listProducts, setListProducts] = useState([]);
  const [storeName, setStoreName] = useState("");
  const checkStatusColor = (checkStatusColor) => {
    let color = "";
    switch (checkStatusColor) {
      case "Pending":
        color = "#ffb302";
        break;
      case "Active":
        color = "#5AA700";
        break;
      case "Blocked":
        color = "#ff3838";
        break;
      case "Deactivate":
        color = "#2E6FD9";
        break;
      default:
        color = "rgba(230, 126, 34, 0.7)";
    }

    return color;
  };

  const retrivingAllProductsOfStore = async (id) => {
    await api
      .get(`/superAdmin/products/store/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        console.log("res is ", res.data.data.product);
        setListProducts(res.data.data.product);
        console.log("ListProdcuts are ", listProducts);
      })
      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error.response.data.error))
      );
  };

  const handerChangeStatus = (id) => async (e) => {
    let newStatus = e.target.value;
    const newStoresList = details.map((el) =>
      el._id === id ? { ...el, status: newStatus } : el
    );

    console.log(newStoresList);

    await api
      .patch(
        `/superAdmin/store/${id}`,
        { status: newStatus },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(() => {
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "SUCCESS: Status has been Changed!",
          open: true,
        });
        setDetails(newStoresList);
      })
      .catch((error) => {
        setSnackBar({
          ...snackBarstate,
          type: "error",
          message: "ERROR: Something went Wrong!",
          open: true,
        });
      });
  };
  const columnsProduct = [
    {
      title: "ID",
      field: "tableData.id",
      render: ({ tableData }) => <div>{tableData.id + 1}</div>,
      hidden: false,
      export: false,
    },
    {
      title: "Image",
      field: "images",
      render: ({ images }) => (
        <img
          src={images.length > 0 ? images[0] : ImgNotAvailable}
          alt="ProductImage"
          style={{ width: 40, height: 40, borderRadius: "50%" }}
        />
      ),
      hidden: false,
      export: false,
    },
    { title: "Name", field: "name", hidden: false, export: true },
    {
      title: "description",
      field: "description",
      hidden: true,
      export: true,
    },
    {
      title: "Vendor Name",
      field: "vendorCompanyName",
      hidden: false,
      export: true,
    },
    { title: "Category", field: "category", hidden: false, export: true },
    {
      title: "purchasePrice",
      field: "purchasePrice",
      hidden: true,
      export: true,
    },
    {
      title: "SalePrice",
      field: "salePrice",
      render: ({ salePrice }) => <div>{"Rs." + salePrice}</div>,
      hidden: false,
      export: true,
    },
    {
      title: "State",
      field: "state",
      hidden: false,
      export: true,
    },
    {
      title: "StockAvailable",
      field: "stockAvailable",
      hidden: false,
      export: true,
    },
    {
      title: "discountPercentage",
      field: "discountPercentage",
      hidden: true,
      export: true,
    },
    { title: "Warranty", field: "warranty", hidden: false, export: true },
    {
      title: "Colors",
      field: "colors",
      render: ({ colors }) => <div>{colors[0]}</div>,
      hidden: true,
      export: false,
    },
    {
      title: "isVisibilityEnabled",
      field: "isVisibilityEnabled",
      render: ({ isVisibilityEnabled }) => <div>{isVisibilityEnabled}</div>,
      hidden: true,
      export: true,
    },
    {
      title: "manufactureDate",
      field: "manufactureDate",
      hidden: true,
      export: true,
    },
    {
      title: "shippingCost",
      field: "shippingCost",
      hidden: true,
      export: true,
    },
    {
      title: "dimensions",
      field: "dimensions",
      hidden: true,
      export: true,
    },
    {
      title: "weight",
      field: "weight",
      hidden: true,
      export: true,
    },
  ];

  const columnsStore = [
    {
      title: "ID",
      field: "tableData.id",
      render: ({ tableData }) => <div>{tableData.id + 1}</div>,
      hidden: false,
      export: false,
    },
    { title: "Name", field: "name" },
    { title: "Biography", field: "biography" },
    { title: "Category", field: "category" },
    { title: "Address", field: "warehouseAddress" },

    { title: "City", field: "city" },
    {
      title: "Status",
      field: "status",
      align: "center",
      render: ({ status }) => (
        <div
          style={{
            height: 30,
            width: 100,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: checkStatusColor(status),
            color: "white",
            borderRadius: 4,
          }}
        >
          {status}
        </div>
      ),
    },
    {
      field: "Actions",
      title: "Actions",
      align: "center",
      render: (rowData) => (
        <div>
          <Select
            id="status"
            style={{ marginTop: 8 }}
            defaultValue={"DEFAULT"}
            onChange={handerChangeStatus(rowData._id)}
          >
            <MenuItem value="DEFAULT" disabled>
              Status
            </MenuItem>
            <MenuItem value="Active">Active</MenuItem>
            <MenuItem value="Pending">Pending</MenuItem>
            <MenuItem value="Deactivate">Deactivate</MenuItem>
            <MenuItem value="Blocked">Blocked</MenuItem>
          </Select>
        </div>
      ),
      export: false,
    },
  ];

  // category list retrive from DB
  const [productCategories, setProductCategories] = useState([]);
  const [productSubCategories, setProductSubCategories] = useState([]);
  const [productBrand, setProductBrand] = useState([]);
  const [productDetails, setProductDetails] = useState({
    name: "test",
    description: "test",
    category: "",
    subCategory: "",
    manufactureDate: "11/06/2003",
    purchasePrice: "1000",
    salePrice: "1000",
    state: "New",
    shippingCost: "20",
    images: [""],
    discountPercentage: 10,
    discountPrice: 0,
    stockAvailable: 0,
    dimensions: "",
    isOnSale: false,
    warranty: "",
    weight: "",
  });
  const [colors, setColors] = useState([]);
  const [dimensions, setDimensions] = useState({
    length: "",
    width: "",
    height: "",
    unit: "in",
  });
  const [warranty, setWarranty] = useState("");
  const [warrantySpan, setWarrantySpan] = useState("year");
  const [weight, setWeight] = useState("");
  const [weightUnits, setWeightUnits] = useState("Kg");

  const handlerColor = () => (e) => {
    var newColor = e.target.value;

    const found = colors.some((el) => el === newColor);
    if (!found) {
      setColors([...colors, e.target.value]);
    }
  };

  const handleDeleteColor = (el) => () => {
    setColors((colors) => colors.filter((color, index) => index !== el));
  };

  // updating BankDetails usestate
  const handleProductDetails = (input) => (e) => {
    setProductDetails({ ...productDetails, [input]: e.target.value });
  };

  const HanderdiscountSwitch = (e) => {
    setProductDetails({ ...productDetails, isOnSale: e.target.checked });
  };

  const handlerDiscount = (input) => (e) => {
    const discount = e.target.value;

    var discountPrice =
      productDetails.salePrice - productDetails.salePrice * (discount / 100);

    setProductDetails({
      ...productDetails,
      [input]: e.target.value,
      discountPrice,
    });

    console.log(productDetails);
  };
  const handleWarranty = (e) => {
    setWarranty(e.target.value);
  };
  const handleWarrantySpan = (e) => {
    setWarrantySpan(e.target.value);
  };
  const handleWeight = (e) => {
    setWeight(e.target.value);
  };
  const handleWeightUnit = (e) => {
    setWeightUnits(e.target.value);
  };

  const handlerDimension = (input) => (e) => {
    setDimensions({ ...dimensions, [input]: e.target.value });
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const fileHandler = async (event) => {
    let prevImages = productDetails.images;
    let files = event.target.files;
    let temp = [];

    for (let i = 0; i < files.length; i++) {
      var file64 = await toBase64(files[i]);
      temp.push(file64);
    }

    if (prevImages.length > 0) {
      setProductDetails({
        ...productDetails,
        images: [...prevImages, ...temp],
      });
    } else {
      setProductDetails({
        ...productDetails,
        images: temp,
      });
    }
  };

  const handlerDeletePImage = (index) => {
    const pImages = productDetails.images.filter(
      (el, eindex) => eindex !== index
    );

    setProductDetails({
      ...productDetails,
      images: pImages,
    });
  };
  const [storeId, setStoreId] = useState("");

  const [IFerrors, setIFerrors] = useState({
    nameError: "",
    descriptionError: "",
    categoryError: "",
    subCategoryError: "",
    purchasePriceError: "",
    salePriceError: "",
    stateError: "",
    shippingCostError: "",
    stockError: "",
    warrantyError: "",
    weightError: "",
    dimensionsError: "",
    discountPercentageError: "",
  });

  const InputValidation = () => {
    const errors = {};
    var hasError = false;

    // name
    var nameFormat = /^[0-9A-Za-z\s_+()'#@&-]+$/;
    if (productDetails.name.match(nameFormat)) {
      errors.nameError = "";
    } else {
      hasError = true;
      errors.nameError =
        "Invalid Input. Name cannot contains several Special Characters!";
    }

    // description
    var descFormat = /^[A-Za-z0-9.,'!()#&+-\s]+$/;
    if (productDetails.description.match(descFormat)) {
      errors.descriptionError = "";
    } else {
      hasError = true;
      errors.descriptionError =
        "Description contains several characters that aren't allowed!";
    }

    // Product category
    if (productDetails.category.length === 0) {
      hasError = true;
      errors.categoryError = "Please Choose a Category for Product!";
    } else {
      errors.categoryError = "";
    }

    // subcategory
    if (productDetails.subCategory.length === 0) {
      hasError = true;
      errors.subCategoryError = "Please Choose Sub-Category for Product!";
    } else {
      errors.subCategoryError = "";
    }

    // state
    if (productDetails.state.length === 0) {
      hasError = true;
      errors.stateError = "Please Choose the Product State!";
    } else {
      errors.stateError = "";
    }

    // stock
    var stockFormat = /^[1-9]\d*$/;
    if (productDetails.stockAvailable.toString().match(stockFormat)) {
      errors.stockError = "";
    } else {
      hasError = true;
      errors.stockError = "Entered stock amount is invalid.";
    }

    // Shipping cost
    var shippingFormat = /^[1-9]\d*$/;
    if (productDetails.shippingCost.toString().match(shippingFormat)) {
      errors.shippingCostError = "";
    } else {
      hasError = true;
      errors.shippingCostError = "Entered Shipping Amount is invalid.";
    }

    // price
    var PriceFormat = /^\d+(.\d{1,2})?$/;
    if (productDetails.purchasePrice.toString().match(PriceFormat)) {
      errors.purchasePriceError = "";
    } else {
      hasError = true;
      errors.purchasePriceError = "Entered Amount is invalid.";
    }

    if (productDetails.salePrice.toString().match(PriceFormat)) {
      errors.salePriceError = "";
    } else {
      hasError = true;
      errors.salePriceError = "Entered Amount is invalid.";
    }

    // warranty
    var warrantyFormat =
      /[0-9]+\s[\bday\b|\bdays\b|\byear\b|\byears\b|\bmonth\b|\bmonths\b|\bweek\b|\bweeks\b]+/;
    if (productDetails.warranty.match(warrantyFormat)) {
      errors.warrantyError = "";
    } else {
      hasError = true;
      errors.warrantyError = "Entered Warranty is invalid.";
    }

    // weight
    var weightFormat =
      /[0-9]+\s[\bgram\b|\bgrams\b|\bkilogram\b|\bkilograms\b|\bmiligram\b|\bmiligrams\b]+/;
    if (productDetails.weight.match(weightFormat)) {
      errors.weightError = "";
    } else {
      hasError = true;
      errors.weightError = "Entered Weight Amount is invalid.";
    }

    if (productDetails.isOnSale === true) {
      // discountFormat
      var discountFormat = /\b(0*([1-9][0-9]?|100))\b/;
      if (productDetails.discountPercentage.toString().match(discountFormat)) {
        errors.discountError = "";
      } else {
        hasError = true;
        errors.discountError = "Entered Discount Amount is invalid.";
      }
    }

    setIFerrors({ ...IFerrors, ...errors });
    return hasError;
  };
  const editProductHandler = (e) => {
    e.preventDefault();

    var hasError = InputValidation();

    if (hasError === false) {
      api
        .patch(
          `/superAdmin/product/${productDetails._id}`,
          {
            ...productDetails,
            colors,
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          const newDetails = details.map((prod) =>
            prod._id === productDetails._id ? productDetails : prod
          );
          setDetails(newDetails);
          handleClose();
          setSnackBar({
            ...snackBarstate,
            type: "success",
            message: "SUCCESS: Product has been Updated!",
            open: true,
          });
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch(() => {
          handleClose();
          setSnackBar({
            ...snackBarstate,
            message: "ERROR: Something is not working properly!",
            type: "error",
            open: true,
          });
        });
    }
  };

  const editStoreHandler = (e) => {
    e.preventDefault();
    const {
      name,
      category,
      biography,
      warehouseAddress,
      buissnessAddress,
      city,
      country,
      type,
    } = storeDetails;

    api
      .patch(
        `/superAdmin/store/${storeId}`,
        {
          name,
          category,
          biography,
          warehouseAddress,
          buissnessAddress,
          city,
          country,
          type,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        try {
          const newDetails = details.map((prod) =>
            prod._id === storeDetails._id ? storeDetails : prod
          );
          setDetails(newDetails);
          handleClose();
          setSnackBar({
            ...snackBarstate,
            type: "success",
            message: "SUCCESS: Store has been Updated!",
            open: true,
          });
        } catch (error) {}
      })
      .catch((error) => {
        handleClose();
        setSnackBar({
          ...snackBarstate,
          message: "ERROR: Something is not working properly!",
          type: "error",
          open: true,
        });
      });
  };

  // View Product Modal Settings here
  const [modalOpenViewProduct, setModelOpenViewProduct] = useState(false);
  const handleOpenViewProduct = () => {
    setModelOpenViewProduct(true);
  };
  const handleCloseViewProduct = () => {
    setModelOpenViewProduct(false);
  };

  // Edit Store Settings here
  const [modalOpen, setModelOpen] = useState(false);
  const handleOpen = () => {
    setModelOpen(true);
  };
  const handleClose = () => {
    setModelOpen(false);
  };

  // Edit Product Modal Settings here
  const [modalOpenEditProduct, setModelOpenEditProduct] = useState(false);
  const handleOpenEditProduct = () => {
    setModelOpenEditProduct(true);
  };
  const handleCloseEditProduct = () => {
    setModelOpenEditProduct(false);
  };

  const retrivingAllStores = async () => {
    await api
      .get("/superAdmin/stores", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        console.log("All Stores Are ", res.data.data.stores);
        setDetails(res.data.data.stores);
      })
      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error.response.data.error))
      );
  };
  const [vendorCategories, setVendorCategories] = useState([]);
  const getVendorCategory = async () => {
    // Parent Category
    api
      .get("/admin/vendorCategories", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        console.log(res.data.data);
        const categoryList = res.data.data.categories;
        setVendorCategories(categoryList);
      })
      .catch((error) => console.log("Error: " + error));
  };

  const getAllCategory = async () => {
    // Parent Category
    api
      .get("/superAdmin/product/categories/view", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const categoryList = res.data.data.categories;
        // console.log("categories are ", categoryList);
        setProductCategories(categoryList);
      })
      .catch((error) => console.log("Error: " + error));
  };

  const getSubCategory = async () => {
    console.log(productDetails.category);
    if (productDetails.category !== "") {
      await api
        .get(`/superAdmin/subCategories/${productDetails.category}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          let categoryList = res.data.data.categories;
          let subCat = categoryList.map((el) => el.subCategory);
          let brands = categoryList.map((el) => el.brands);
          setProductSubCategories(subCat[0]);
          setProductBrand(brands[0]);
        })
        .catch((error) => console.log("Error: " + error));
    }
  };

  useEffect(() => {
    // Retriving List of Products from API
    retrivingAllStores();
    // eslint-disable-next-line
    getVendorCategory();
    // eslint-disable-next-line
    getAllCategory();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getSubCategory();
    // eslint-disable-next-line
  }, [productDetails.category]);

  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} sm={12} md={10} component={Paper}>
        <MaterialTable
          style={{ width: 1000 }}
          title="All Stores In Digi-Mart"
          data={details}
          columns={columnsStore}
          actions={[
            (rowData) => ({
              icon: () => <VisibilityIcon />,
              tooltip: "View Products Of Store",
              onClick: (event, rowData) => {
                retrivingAllProductsOfStore(rowData._id);
                handleOpenViewProduct();
                setStoreName(rowData.name);
              },
            }),

            (rowData) => ({
              icon: () => <EditIcon />,
              tooltip: "Edit",
              onClick: (event, rowData) => {
                setStoreDetails(rowData);
                setStoreId(rowData._id);
                handleOpen();
              },
            }),
            (rowData) => ({
              icon: () => <AssessmentIcon />,
              tooltip: "Statistics",
              onClick: (event, rowData) => {
                // setStoreDetails(rowData);
                // setStoreId(rowData._id);
                // handleOpen();
              },
            }),
          ]}
          options={{
            actionsColumnIndex: -1,

            headerStyle: {
              backgroundColor: Pal.palette.primary.main,
              color: "#fff",
              whiteSpace: "nowrap",
            },
            exportButton: true,
            tableLayout: "auto",
          }}
        />
        <Snackbar
          open={open}
          anchorOrigin={{ vertical, horizontal }}
          autoHideDuration={3000}
          onClose={handleCloseSnackBar}
          key={vertical + horizontal}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            onClose={handleCloseSnackBar}
            severity={snackBarstate.type}
          >
            {snackBarstate.message}
          </MuiAlert>
        </Snackbar>
      </Grid>
      {/* /////////////////////Edit Store/////////////////////////////////// */}
      <Modal
        open={modalOpen}
        onClose={handleClose}
        onBackdropClick={handleClose}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Container component={Paper} maxWidth="md" style={{ padding: 20 }}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={12} align="center">
              <Typography variant="h5">Add Store Details</Typography>
            </Grid>
            <form className={classes.form} noValidate style={{ padding: 20 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <TextField
                    label="Store Name"
                    fullWidth
                    value={storeDetails.name}
                    onChange={handleStoreDetails("name")}
                    helperText={IFerrors.nameError}
                    error={IFerrors.nameError.length > 0 ? true : false}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <FormControl fullWidth>
                    <InputLabel>Category</InputLabel>
                    <Select
                      native
                      defaultValue={storeDetails.category}
                      onChange={handleStoreDetails("category")}
                    >
                      <option value="Electronic">Electronics</option>
                      <option value="Health">Health and Beauty</option>
                      <option value="Groceries">Groceries & Pets</option>
                      <option value="Lifestyle">Home & Lifestyle</option>
                      <option value="fashion">Fashion & Clothing</option>
                      <option value="sports">Sports</option>
                      <option value="automotive">Automotive and Bikes</option>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    name="storeBio"
                    label="Biography"
                    fullWidth
                    defaultValue={storeDetails.biography}
                    onChange={handleStoreDetails("biography")}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <TextField
                    required
                    name="warehouseAddress"
                    label="Warehouse Address"
                    fullWidth
                    defaultValue={storeDetails.warehouseAddress}
                    onChange={handleStoreDetails("warehouseAddress")}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <TextField
                    required
                    name="warehouseAddress"
                    label="Warehouse Address"
                    fullWidth
                    defaultValue={storeDetails.warehouseAddress}
                    onChange={handleStoreDetails("warehouseAddress")}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <TextField
                    required
                    name="city"
                    label="City"
                    fullWidth
                    defaultValue={storeDetails.city}
                    onChange={handleStoreDetails("city")}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    name="country"
                    label="Country"
                    fullWidth
                    defaultValue={storeDetails.country}
                    onChange={handleStoreDetails("country")}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <RadioGroup
                    row
                    value={storeDetails.type}
                    onChange={handleStoreDetails("type")}
                  >
                    <FormControlLabel
                      value="individual"
                      control={<Radio color="secondary" />}
                      label="I'm an Individual"
                    />
                    <FormControlLabel
                      value="shop"
                      control={<Radio color="secondary" />}
                      label="I'm a Shopkepper"
                    />
                    <FormControlLabel
                      value="brand"
                      control={<Radio color="secondary" />}
                      label="We're a Brand"
                    />
                  </RadioGroup>
                </Grid>
                <Grid item xs={12}></Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={12} align="right">
                <Button
                  variant="outlined"
                  color="primary"
                  style={{ marginRight: 10 }}
                  onClick={handleClose}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={editStoreHandler}
                >
                  Save Changes
                </Button>
              </Grid>
            </form>
          </Grid>
        </Container>
      </Modal>

      {/* Edit Product Modal */}
      <Modal
        open={modalOpenEditProduct}
        onClose={handleCloseEditProduct}
        onBackdropClick={handleCloseEditProduct}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Container
          component={Paper}
          style={{
            padding: "20px",
            maxWidth: "50vw",
            maxHeight: "80vh",
            overflow: "auto",
            scrollbarWidth: "2px",
          }}
        >
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={12} align="center">
              <Typography variant="h5">Edit Product</Typography>
            </Grid>
            <form className={classes.form} noValidate style={{ padding: 20 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    margin="dense"
                    variant="outlined"
                    required
                    fullWidth
                    label="Name"
                    value={productDetails.name}
                    onChange={handleProductDetails("name")}
                    helperText={IFerrors.nameError}
                    error={IFerrors.nameError.length > 0 ? true : false}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    multiline
                    rows={4}
                    label="Description"
                    value={productDetails.description}
                    onChange={handleProductDetails("description")}
                    helperText={IFerrors.descriptionError}
                    error={IFerrors.descriptionError.length > 0 ? true : false}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Select
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Category"
                    style={{ marginTop: 8 }}
                    value={productDetails.category}
                    defaultValue={"DEFAULT"}
                    onChange={handleProductDetails("category")}
                    error={IFerrors.categoryError.length > 0 ? true : false}
                  >
                    <MenuItem value="DEFAULT" disabled>
                      Choose a Product Category
                    </MenuItem>
                    {productCategories.map((el, index) => (
                      <MenuItem value={el.name} key={index}>
                        {el.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={6}>
                  <Select
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Sub Category"
                    style={{ marginTop: 8 }}
                    defaultValue={"DEFAULT"}
                    value={productDetails.subCategory}
                    onChange={handleProductDetails("subCategory")}
                    error={IFerrors.subCategoryError.length > 0 ? true : false}
                  >
                    <MenuItem value="DEFAULT" disabled>
                      Choose sub-category
                    </MenuItem>
                    {productSubCategories.map((el, index) => (
                      <MenuItem value={el.name} key={index}>
                        {el.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    placeholder="dd/MM/YYYY"
                    label="Manufacture Date"
                    name="manufactureDate"
                    value={productDetails.manufactureDate}
                    onChange={handleProductDetails("manufactureDate")}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Select
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Category"
                    name="category"
                    style={{ marginTop: 8 }}
                    value={"DEFAULT"}
                    defaultValue={"DEFAULT"}
                    onChange={handlerColor("colors")}
                  >
                    <MenuItem value="DEFAULT" disabled>
                      Select Product Color
                    </MenuItem>
                    <MenuItem value="Red">Red</MenuItem>
                    <MenuItem value="Green">Green</MenuItem>
                    <MenuItem value="Black">Black</MenuItem>
                    <MenuItem value="Purple">Purple</MenuItem>
                  </Select>
                </Grid>

                {colors.length > 0 ? (
                  <Grid item xs={12}>
                    {colors.map((el, index) => (
                      <Chip
                        label={el}
                        key={index}
                        onDelete={handleDeleteColor(index)}
                        style={{
                          margin: "2px 4px",
                        }}
                      />
                    ))}
                  </Grid>
                ) : (
                  ""
                )}

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    name="stock"
                    label="Stock / Quantity"
                    value={productDetails.stockAvailable}
                    onChange={handleProductDetails("stockAvailable")}
                    helperText={IFerrors.stockError}
                    error={IFerrors.stockError.length > 0 ? true : false}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    name="warranty"
                    label="Warranty"
                    value={productDetails.warranty}
                    onChange={handleProductDetails("warranty")}
                    helperText={IFerrors.warrantyError}
                    error={IFerrors.warrantyError.length > 0 ? true : false}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Purchase Price"
                    value={productDetails.purchasePrice}
                    onChange={handleProductDetails("purchasePrice")}
                    helperText={IFerrors.purchasePriceError}
                    error={
                      IFerrors.purchasePriceError.length > 0 ? true : false
                    }
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Sale Price (Rs)"
                    name="salePrice"
                    value={productDetails.salePrice}
                    onChange={handleProductDetails("salePrice")}
                    helperText={IFerrors.salePriceError}
                    error={IFerrors.salePriceError.length > 0 ? true : false}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Weight"
                    id="weight"
                    name="weight"
                    value={productDetails.weight}
                    onChange={handleProductDetails("weight")}
                    helperText={IFerrors.weightError}
                    error={IFerrors.weightError.length > 0 ? true : false}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Select
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Product State"
                    name="state"
                    style={{ marginTop: 8 }}
                    defaultValue={"DEFAULT"}
                    value={productDetails.state}
                    onChange={handleProductDetails("state")}
                  >
                    <MenuItem value="DEFAULT">
                      Select the Product State
                    </MenuItem>
                    <MenuItem value="New">New</MenuItem>
                    <MenuItem value="Used">Used</MenuItem>
                    <MenuItem value="Refurbished">Refurbished</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Shipping Cost"
                    name="shippingCost"
                    value={productDetails.shippingCost}
                    onChange={handleProductDetails("shippingCost")}
                    helperText={IFerrors.shippingCostError}
                    error={IFerrors.shippingCostError.length > 0 ? true : false}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Dimensions"
                    placeholder="100in 100in 100in"
                    value={productDetails.dimensions}
                    onChange={handleProductDetails("dimensions")}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginLeft: 10,
                    marginRight: 10,
                    marginTop: 20,
                    marginBottom: 5,
                    padding: 20,
                    height: 120,
                    border: "1px solid #c4c4c4",
                    borderRadius: 6,
                  }}
                >
                  <Grid container justify="center" spacing={2}>
                    {productDetails.images.length > 0 ? (
                      productDetails.images.map((img, index) => (
                        <Grid item key={index} align="center">
                          <img
                            src={img}
                            alt="product-images"
                            width="60px"
                            height="60px"
                            style={{
                              border: "3px solid #e1e1e1",
                              padding: "2px",
                            }}
                          />
                          <div>
                            <HighlightOffRoundedIcon
                              onClick={() => handlerDeletePImage(index)}
                              style={{
                                color: "grey",
                              }}
                            />
                          </div>
                        </Grid>
                      ))
                    ) : (
                      <Typography>Upload Product Images</Typography>
                    )}
                  </Grid>
                </Grid>
                <Grid item style={{ marginBottom: 10, marginLeft: 10 }}>
                  <div>
                    <label htmlFor="contained-button-file">
                      <Button
                        size="small"
                        startIcon={<AddPhotoAlternateIcon />}
                        variant="outlined"
                        color="primary"
                        component="span"
                      >
                        Upload Images
                      </Button>
                    </label>
                    <input
                      id="contained-button-file"
                      type="file"
                      multiple
                      accept="image/png, image/jpeg"
                      onChange={fileHandler}
                      hidden
                    />
                  </div>
                </Grid>

                <Grid
                  container
                  spacing={2}
                  style={{ marginLeft: 5, marginRight: 5 }}
                >
                  <Grid item xs={4}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        border: "1px solid #c4c4c4",
                        borderRadius: 4,
                        marginTop: 8,
                      }}
                    >
                      <FormControlLabel
                        margin="normal"
                        control={
                          <Switch
                            color="primary"
                            checked={productDetails.isOnSale}
                            onChange={HanderdiscountSwitch}
                          />
                        }
                        label="On Sale"
                        labelPlacement="start"
                      />
                    </div>
                  </Grid>

                  {productDetails.isOnSale ? (
                    <Grid item xs={8}>
                      <TextField
                        variant="outlined"
                        margin="dense"
                        required
                        fullWidth
                        label="Discount(%)"
                        id="discount"
                        name="discount"
                        value={productDetails.discountPercentage}
                        onChange={handlerDiscount("discountPercentage")}
                        helperText={IFerrors.discountPercentageError}
                        error={
                          IFerrors.discountPercentageError.length > 0
                            ? true
                            : false
                        }
                      />
                    </Grid>
                  ) : (
                    ""
                  )}
                </Grid>

                {/* SAVE CHANGES BUTTON */}
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  align="center"
                  style={{ margin: "20px 0" }}
                >
                  <Button
                    variant="outlined"
                    color="primary"
                    style={{ marginRight: 10 }}
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={editProductHandler}
                  >
                    Save Changes
                  </Button>
                </Grid>
              </Grid>

              <Snackbar
                open={open}
                anchorOrigin={{ vertical, horizontal }}
                autoHideDuration={3000}
                onClose={handleCloseSnackBar}
                key={vertical + horizontal}
              >
                <MuiAlert
                  elevation={6}
                  variant="filled"
                  onClose={handleCloseSnackBar}
                  severity={snackBarstate.type}
                >
                  {snackBarstate.message}
                </MuiAlert>
              </Snackbar>
            </form>
          </Grid>
        </Container>
      </Modal>

      {/* ////////////////////////View Store Products Modal //////////////////////////////// */}
      <Modal
        open={modalOpenViewProduct}
        onClose={handleCloseViewProduct}
        onBackdropClick={handleCloseViewProduct}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Container
          component={Paper}
          style={{
            padding: "20px",
            maxWidth: "50vw",
            maxHeight: "80vh",
            overflow: "auto",
            scrollbarWidth: "2px",
          }}
        >
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={12} align="center">
              <Typography variant="h5">All Products Of {storeName}</Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} component={Paper}>
              <MaterialTable
                title="Products"
                data={listProducts}
                columns={columnsProduct}
                actions={[
                  (rowData) => ({
                    icon: () => <VisibilityIcon />,
                    tooltip: "View Products",
                    onClick: (event, rowData) => {
                      // handleOpenProduct();
                    },
                  }),
                  (rowData) => ({
                    icon: () => <EditIcon />,
                    tooltip: "Edit",
                    onClick: (event, rowData) => {
                      setProductDetails(rowData);
                      handleOpenEditProduct();
                    },
                  }),
                ]}
                options={{
                  actionsColumnIndex: -1,
                  headerStyle: {
                    backgroundColor: Pal.palette.primary.main,
                    color: "#fff",
                    whiteSpace: "nowrap",
                  },
                  exportButton: true,
                  tableLayout: "auto",
                }}
              />
              <Snackbar
                open={open}
                anchorOrigin={{ vertical, horizontal }}
                autoHideDuration={3000}
                onClose={handleCloseSnackBar}
                key={vertical + horizontal}
              >
                <MuiAlert
                  elevation={6}
                  variant="filled"
                  onClose={handleCloseSnackBar}
                  severity={snackBarstate.type}
                >
                  {snackBarstate.message}
                </MuiAlert>
              </Snackbar>
            </Grid>
          </Grid>
        </Container>
      </Modal>

      <Snackbar
        open={open}
        anchorOrigin={{ vertical, horizontal }}
        autoHideDuration={3000}
        onClose={handleCloseSnackBar}
        key={vertical + horizontal}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleCloseSnackBar}
          severity={snackBarstate.type}
        >
          {snackBarstate.message}
        </MuiAlert>
      </Snackbar>
    </Grid>
  );
}
